// extracted by mini-css-extract-plugin
export default {"container":"TermsAndConditionsPage_container__KnmxY"};